import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GeneralUtilities } from 'src/app/utilities/generaleUtilities';

@Component({
  selector: 'app-tank-volume-graphic',
  templateUrl: './tank-volume-graphic.component.svg',
  styleUrls: ['./tank-volume-graphic.component.css'],
})
export class TankVolumeGraphicComponent {
  //private _fillColor: string = 'rgb(87, 124, 207)';
  readonly defaultFillColor: string = 'rgb(0, 171, 78)';
  _fillColor: string = this.defaultFillColor;
  public get fillColor(): string {
    return this._fillColor;
  }

  @Input() height: string = '156px';

  @Input()
  public set fillColor(value: string) {
    if (value === null || !value) return;

    //build the pallet of colors needed
    this._fillColor = value;
    if(value === 'transparent'){
      value = this.defaultFillColor
    }

    this.tankVolumeChartBorderColor = GeneralUtilities.lightenRGBcolor(
      value,
      60
    );
    this.gradientDarkestColor = GeneralUtilities.lightenRGBcolor(value, 2);
    this.gradientLightestColor = GeneralUtilities.lightenRGBcolor(value, 85);
    this.cdr.detectChanges();
  }

  private _tankLevelPercent: number | null = null;
  public get tankLevelPercent(): number | null {
    return this._tankLevelPercent;
  }
  @Input()
  public set tankLevelPercent(volume: number | null) {
    this._tankLevelPercent = volume;
    this.redrawTankVolume(volume);
    this.cdr.detectChanges();
  }

  private _showVolumeLevelLabels: boolean = true;
  public get showVolumeLevelLabels(): boolean {
    return this._showVolumeLevelLabels;
  }
  @Input()
  public set showVolumeLevelLabels(value: boolean) {
    this._showVolumeLevelLabels = value;
    this.cdr.detectChanges();
  }

  @Input()
  tankCapacity: number = 0;

  @Input()
  volumeSuffix: string = '';

  volumeChartXPoint: number = 0;
  tankVolumeChartBorderColor: string = '';
  lighterColor: string = '';
  gradientDarkestColor: string = '';
  gradientLightestColor: string = '';

  constructor(private cdr: ChangeDetectorRef) {}
  private redrawTankVolume(volumeLevel: number | null) {
    if (volumeLevel === null) return;

    //manually calculate & build the svg path for the volume chart's fluid fill line
    const targetPlotPoint = 86; //the y coordinate of the bottom of the tank
    const y = targetPlotPoint - targetPlotPoint * volumeLevel;
    this.volumeChartXPoint = y;
  }

  tankVolumePath() {
    return `M4.5 86  H 61 V ${this.volumeChartXPoint} H 4.5 Z`; // SVG Path needed for the tank volume chart level.
  }
}
